module.exports = require('./$.hide');


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/$.redef.js
 ** module id = 251
 ** module chunks = 46 47
 **/